import AbstractRequestTask from "../AbstractRequestTask";
import device from "../../../devices/device";
import storage from '../../../components/DeviceStorage/DeviceStorage';
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';


class ReminderCreate extends AbstractRequestTask {

  constructor(event_id = '', event_alf_id = '', exp_date ='', type ='', channel_id) {
    super();
      this.event_id = event_id;
      this.event_alf_id = event_alf_id;
      this.exp_date = exp_date;
      this.type = type;
      this.channel_id = channel_id;
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");

    return `${http}${url}/services/user/v1/reminder/create`;
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    const exp_date = this.exp_date;
    const type = this.type;
    const channel_id = this.channel_id;
    let newParamEventAlfId = {};

    if (this.event_alf_id && this.event_alf_id !== null) {
      newParamEventAlfId = {
        event_alf_id: this.event_alf_id,
      };
    } else {
      newParamEventAlfId = {
        event_id: this.event_id
      };
    }

    return Object.assign({}, params, { exp_date, type, channel_id } , newParamEventAlfId);
  }

  isValid(data) {
      if (data.errors || data.status == 1 || data.response === 'error') {
          return false;
      }
      return true;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal() {
    return ENABLE_MODAL_RETRIES;
  }
}

export default ReminderCreate;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/ReminderCreateTask.js